import { styled as _styled } from "../../stitches.config.ts";
import { __ } from '@/lang';
import { motion } from 'framer-motion';
import { keyframes } from 'stitches.config';
import type { MotionProps } from 'framer-motion';
import WorldcoinIcon from './Icons/WorldcoinIcon';
import type { ButtonHTMLAttributes, FC } from 'react';
const MotionButton = motion(_styled("button", {
  ...{
    "position": "relative",
    "overflow": "hidden",
    "borderRadius": "0.75rem",
    "borderStyle": "none",
    "borderColor": "rgb(255 255 255 / 0.1)",
    "paddingLeft": "6rem",
    "paddingRight": "6rem",
    "paddingTop": "1.5rem",
    "paddingBottom": "1.5rem",
    "willChange": "transform",
    "&:focus": {
      "outline": "2px solid transparent",
      "outlineOffset": "2px"
    },
    ".dark &": {
      "borderWidth": "1px"
    }
  },
  variants: {
    theme: {
      dark: {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))"
      },
      light: {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(242 245 249 / var(--tw-bg-opacity))"
      }
    }
  }
}));
const ButtonContent = _styled("div", {
  ...{
    "position": "absolute",
    "top": "1px",
    "right": "1px",
    "bottom": "1px",
    "left": "1px",
    "zIndex": "10",
    "display": "grid",
    "cursor": "pointer",
    "placeItems": "center",
    "borderRadius": "0.75rem"
  },
  variants: {
    theme: {
      dark: {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))"
      },
      light: {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(242 245 249 / var(--tw-bg-opacity))"
      }
    }
  }
});
const disco = keyframes({
  '0%': {
    transform: 'translateY(-50%) rotate(0deg)'
  },
  '100%': {
    transform: 'translateY(-50%) rotate(360deg)'
  }
});
const AnimatedBorder = _styled("span", {
  ...{
    "position": "absolute",
    "top": "0px",
    "right": "0px",
    "bottom": "0px",
    "left": "0px",
    "zIndex": "0",
    "--tw-scale-x": "2.0",
    "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
    "--tw-blur": "blur(8px)",
    "filter": "var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)"
  },
  '&::before': {
    content: `''`,
    animation: `${disco} 1.5s linear infinite`,
    ...{
      "position": "absolute",
      "top": "50%",
      "right": "0px",
      "bottom": "0px",
      "left": "0px",
      "aspectRatio": "1 / 1",
      "backgroundImage": "conic-gradient(var(--tw-gradient-stops))"
    }
  },
  variants: {
    theme: {
      dark: {
        '&::before': {
          "--tw-gradient-from": "#000",
          "--tw-gradient-to": "#000",
          "--tw-gradient-stops": "var(--tw-gradient-from), rgb(255 255 255 / 0.3), var(--tw-gradient-to)"
        }
      },
      light: {
        '&::before': {
          "--tw-gradient-from": "#f2f5f9",
          "--tw-gradient-to": "#e5e7eb",
          "--tw-gradient-stops": "var(--tw-gradient-from), #e5e7eb, var(--tw-gradient-to)"
        }
      }
    }
  }
});
const TextContainer = _styled("div", {
  "display": "flex",
  "alignItems": "center",
  "> :not([hidden]) ~ :not([hidden])": {
    "--tw-space-x-reverse": "0",
    "marginRight": "calc(1rem * var(--tw-space-x-reverse))",
    "marginLeft": "calc(1rem * calc(1 - var(--tw-space-x-reverse)))"
  }
});
const ButtonLabel = _styled("span", {
  "fontFamily": "Rubik, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem"
});
type Props = ButtonHTMLAttributes<HTMLButtonElement> & MotionProps & {
  theme?: 'dark' | 'light';
};
const _TwComponent = _styled(WorldcoinIcon, {
  "height": "1rem",
  "width": "1rem"
});
const SignInButton: FC<Props> = ({
  className,
  theme = 'light',
  ...props
}) => <MotionButton whileHover={{
  scale: 1.02
}} whileTap={{
  scale: 0.98
}} theme={theme} {...props}>
		<ButtonContent theme={theme}>
			<TextContainer>
				<_TwComponent data-tw="h-4 w-4" />
				<ButtonLabel>{__('Sign in with World ID')}</ButtonLabel>
			</TextContainer>
		</ButtonContent>
		<AnimatedBorder aria-hidden theme={theme} />
	</MotionButton>;
export default SignInButton;